import Keycloak from 'keycloak-js';

// Second keycloak-js instance, targeting the hive-platform realm (ADR-007).
// Mirrors keycloak.service.js but is fully independent: a Hive employee logs in
// here against a different realm/issuer than CPO operators. Shares the same
// Keycloak server URL (HIVE_KEYCLOAK_URL).

let keycloak = null;
let initialized = false;

const REFRESH_THRESHOLD_SECONDS = 60;

export function isSkipAuth() {
    return HIVE_SKIP_AUTH === 'true';
}

export function getPlatformKeycloak() {
    if (!keycloak) {
        keycloak = new Keycloak({
            url: HIVE_KEYCLOAK_URL,
            realm: HIVE_PLATFORM_KEYCLOAK_REALM,
            clientId: HIVE_PLATFORM_KEYCLOAK_CLIENT_ID,
        });
    }

    return keycloak;
}

export async function initPlatformKeycloak() {
    if (initialized) {return getPlatformKeycloak();}

    const kc = getPlatformKeycloak();

    await kc.init({
        onLoad: 'login-required',
        checkLoginIframe: false,
        pkceMethod: 'S256',
    });

    initialized = true;

    return kc;
}

export async function getValidPlatformToken() {
    if (isSkipAuth()) {return null;}

    const kc = getPlatformKeycloak();

    if (!kc.authenticated) {return null;}

    try {
        await kc.updateToken(REFRESH_THRESHOLD_SECONDS);
    } catch (err) {
        console.error('Platform token refresh failed; redirecting to login.', err);
        kc.login();
        throw err;
    }

    return kc.token;
}

export function platformLogout() {
    if (isSkipAuth()) {return Promise.resolve();}

    return getPlatformKeycloak().logout({ redirectUri: `${window.location.origin}/platform` });
}

export function platformLogin() {
    return getPlatformKeycloak().login();
}

export function getPlatformTokenParsed() {
    return getPlatformKeycloak().tokenParsed;
}
